export default {
    user: {
        create: {
            title: "Neuer kunde",
            model: {
                email: {
                    label: "E-Mail",
                    placeholder: "E-Mail ausfüllen"
                },
                name: {
                    label: "Name",
                    placeholder: "Füllen Sie den Namen aus"
                },
                country: {
                    label: "Land",
                    placeholder: "Füllen Sie das Land aus"
                },
                approval_manager_email: {
                    label: "E-Mail des Managers",
                    placeholder: "Manager-E-Mail ausfüllen",
                    errors: {
                        different: "Die E-Mail-Adresse des Genehmigungsmanagers muss sich von der E-Mail-Adresse des Benutzers unterscheiden."
                    }
                }
            },
            cta: {
                submit: {
                    text: "Einreichen",
                    processing: "Absenden"
                },
                cancel: {
                    text: "Stornieren"
                }
            }
        },
        country: {
            title: "Benutzerland",
            header: "{email} hat kein Land ausgewählt. Bitte wählen Sie das Land aus.",
            model: {
                country: {
                    label: "Land",
                    placeholder: "Füllen Sie das Land aus"
                }
            },
            cta: {
                submit: {
                    text: "Einreichen",
                    processing: "Absenden"
                },
                cancel: {
                    text: "Stornieren"
                }
            }
        }
    }
}